import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonConstants } from '@app/app-common';

@Component({
  selector: 'details-main',
  standalone: false,
  templateUrl: './details-main.component.html',
  styleUrl: './details-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailsMainComponent {


}
